import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/js/src/collapse.js";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { appName, appLogo } from "../config/appConfig";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSignOut, faSun } from "@fortawesome/free-solid-svg-icons";

const Header = ({ onSuccess }) => {
  const [currentTheme, setCurrentTheme] = useState('light');
  const [activeObject, setActiveObject] = useState({
    home: "active",
    dashboard: "",
    linelist: "",
    alerts: "",
    pathway: "",
    qrcode: "",
    adherance: "",
  });

  const navigate = useNavigate();

  const changeTheme = (theme) => {
    setCurrentTheme(theme)
    if (theme == 'light') {
      document.body.classList.add("theme_light");
    } else {
      document.body.classList.remove("theme_light");
    }
  }
  const setActiveTab = () => {
    let activeStateHolder = {
      home: "",
      dashboard: "",
      linelist: "",
      alerts: "",
      pathway: "",
      qrcode: "",
      adherance: "",
    }
    let currentPath = window.location.pathname.split('/').pop()
    activeStateHolder[currentPath] = "active"
    setActiveObject(activeStateHolder)
  }


  const handleLogout = () => {
    console.log(":inside logout");
    sessionStorage.clear()
    sessionStorage.clear()
    onSuccess()
    navigate("/");
  };

  return (
    <>
      <Navbar bg="light" className="login_navbar" expand="lg">
        {/* <Container> */}
        <Navbar.Collapse href="#">
          <img src={appLogo} className="logoCss" alt="logo" />
          {/* <h4 className="navTitle m-auto">{appName}</h4> */}
          <h4 className="p-1">{sessionStorage.getItem("userData") ? JSON.parse(sessionStorage.getItem("userData")).appname : ""}</h4>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.home}`}>
                <Link
                  to="home"
                  className="nav-link"
                >
                  Home
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.pathway}`}>
                <Link
                  to="pathway"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Pathway
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.adherencecalendar}`}>
                <Link
                  to="adherencecalendar"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Treatment adherence review
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.linelist}`}>
                <Link
                  to="linelist"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Line list
                </Link>
              </li>
              <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.alerts}`}>
                <Link
                  to="alerts"
                  className="nav-link"
                // onClick={() => this.clearIndicator()}
                >
                  Alerts
                </Link>
              </li>
              {/* <li onClick={() => setActiveTab()} className={`nav-item ${activeObject.qrcode}`}>
                <Link
                  to="qrcode"
                  className="nav-link"
                >
                  QR Code Generation
                </Link>
              </li> */}
              <>
                {/* <li className={`nav-item`}>
                    <a
                      className="nav-link"
                      href="/smartsetup/"
                      //onClick={() => this.menuActive("linelist")}
                      target="_blank"
                    >
                      Smart Setup
                    </a>
                  </li> */}
                {/* <li className={`nav-item`}>
                    <a
                      className="nav-link"
                      href="/indexupload/"
                      //onClick={() => this.menuActive("linelist")}
                      target="_blank"
                    >
                      Index Upload
                    </a>
                  </li> */}

              </>
            </ul>
          </div>
          <Button
            outline
            color="light"
            className="logout d-flex"
            onClick={() => handleLogout()}
            style={{ "alignItems": "center" }}
          >
            {" "}
            {/* <Link to="/"> */}
            <span>Logout</span>
            <FontAwesomeIcon className="p-2 m-auto logout btn-outline-light " icon={faSignOut} />
            {/* </Link> */}
          </Button>
          {currentTheme == 'light' ?
            <>
              <FontAwesomeIcon title="Dark Theme" onClick={e => changeTheme('dark')} className="p-2 m-auto logout btn-outline-light " icon={faMoon} />
            </>
            :
            <FontAwesomeIcon title="Light Theme" onClick={e => changeTheme('light')} className="p-2 m-auto logout btn-outline-light " icon={faSun} />}
        </Navbar.Collapse>
        {/* </Container> */}
      </Navbar>
    </>
  );
}

export default Header;
